import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MiddleServiceService } from '../../core/services/middle-service.service';

@Component({
  selector: 'app-redirector',
  templateUrl: './redirector.component.html',
  styles: []
})
export class RedirectorComponent implements OnInit {

  target: string;

  constructor(
    private router: Router,
    private middleService: MiddleServiceService
  ) {
  }

  ngOnInit() {
    if (this.middleService.takeRedirectToDetail()) {
      this.router.navigate(['docout', { outlets: { contenido: ['detalle/' + this.middleService.redirectTo] } }]);
      this.middleService.redirectTo = '';
    } else {
      this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
    }
  }

}
